const CONTRACT_TYPE_OPTIONS = [
  { value: 'outsourcing', label: '業務委託契約' },
  { value: 'nda', label: '秘密保持契約' },
  { value: 'other', label: 'その他（自由入力）' },
];

export default CONTRACT_TYPE_OPTIONS;
